import { UserContentDetails } from '@/domain/usecases/content/user-content-details'

export namespace ProductType {
  export class Enum {
    static readonly SINGLE_OFFER = new Enum('SINGLE_OFFER')
    static readonly MULTIPLE_OFFERS = new Enum('MULTIPLE_OFFERS')
    static readonly MULTIPLE_VALUES = new Enum('MULTIPLE_VALUES')

    public constructor(public readonly name: string) {}

    is(content: UserContentDetails.Model): boolean {
      return this.name === content.productType.name
    }
  }

  export const getByName = (name: string): Enum => {
    return Object.values(ProductType.Enum).find(type => type.name === name)
  }
}
